import { FormValidator } from '../../../utils';

export class PlanToolValidator extends FormValidator {
  // Retirement Date validator
  projectedRetirementDate(validator) {
    validator.isRequired();
    validator.validDate();
  }
}
